var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarSignIcon = function SvgDollarSignIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.25.75C7.25.334 7.584 0 8 0s.75.334.75.75V2h2c.416 0 .75.334.75.75s-.334.75-.75.75H6.688C5.756 3.5 5 4.256 5 5.188c0 .825.597 1.528 1.41 1.662l3.315.553A3.322 3.322 0 0 1 9.178 14H8.75v1.25c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75V14h-2.5a.75.75 0 0 1-.75-.75c0-.416.334-.75.75-.75h4.428a1.822 1.822 0 0 0 .3-3.619l-3.315-.553A3.185 3.185 0 0 1 6.688 2h.562z"
  })));
};
export default SvgDollarSignIcon;